import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-sm-3"
}
const _hoisted_3 = { class: "w-100 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Código", -1)
const _hoisted_5 = { class: "form-control form-control-solid mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Nombres", -1)
const _hoisted_7 = { class: "form-control form-control-solid mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Apellidos", -1)
const _hoisted_9 = { class: "form-control form-control-solid mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Identificación", -1)
const _hoisted_11 = { class: "form-control form-control-solid mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Sexo", -1)
const _hoisted_13 = { class: "form-control form-control-solid mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder" }, "Fecha de nacimiento", -1)
const _hoisted_15 = { class: "form-control form-control-solid mb-4" }
const _hoisted_16 = { class: "d-none" }
const _hoisted_17 = { class: "col-sm-9" }
const _hoisted_18 = ["src", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_dialog_view_file,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open_dialog_view_file) = $event)),
    title: "Visor de archivos",
    draggable: "",
    top: "2vh",
    fullscreen: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.gblRowAcrd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_image, {
                  src: `${_ctx.serverFile}/${_ctx.gblRowAcrd?.photo}`,
                  class: "h-200px m-auto"
                }, null, 8, ["src"])
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.gblRowAcrd?.idperson), 1),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.gblRowAcrd?.firstname), 1),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.gblRowAcrd?.lastname) + " " + _toDisplayString(_ctx.gblRowAcrd?.surname), 1),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.gblRowAcrd?.doc_name) + ": " + _toDisplayString(_ctx.gblRowAcrd?.docnumber), 1),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.gblRowAcrd?.gender), 1),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.gblRowAcrd?.birthday), 1),
              _createElementVNode("pre", _hoisted_16, _toDisplayString(_ctx.gblRowAcrd), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("embed", {
            src: `${_ctx.serverFile}/${_ctx.urlFile}`,
            type: "application/pdf",
            width: "100%",
            height: _ctx.altura<=500 ? '500px' : _ctx.altura+'px'
          }, null, 8, _hoisted_18)
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}